import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-counter';
	$(base, context).each(function(){
		var component = $(this);

		var input = component.find('.b-counter-control');
		var increment = component.find('.i-counter-increment');
		var decrement = component.find('.i-counter-decrement');

		function toNum(value) {
			return +String(value).replace(/[^\d-]/, '') || 0;
		}

		function setVal(value, inc) {
			var newValue = toNum(value) + toNum(inc);

			newValue = Math.max(newValue, toNum(input.data('min')));
			newValue = Math.min(newValue, toNum(input.data('max')));

			if (input.val() !== String(newValue)) {
				input.val(newValue).trigger('change');
			}
		}

		decrement.on('click', function(e) {
			e.preventDefault();
			setVal(input.val(), -1);
		});

		increment.on('click', function(e) {
			e.preventDefault();
			setVal(input.val(), 1);
		});

		input.on('input', function() {
			setVal(input.val());
		});
	});
});
